export const QuoteQuantityType = Object.freeze({
  DAYS: 'days',
  HOURS: 'hours',
})
